// string
export const isString = (value) => typeof value === 'string';
export const isStringFull = (value) => value.length > 0;
export const isEmptyString = (value) => value.length === 0;
// nil
export const isNull = (value) => value === null;
export const isUndefined = (value) => value === undefined;
export const isNil = (value) => value == null;
export const isDefined = (value) => value != null;
// object
export const isObject = (value) => typeof value === 'object' && value != null;
export const isObjectFull = (value) => isObject(value) && Object.keys(value).length > 0;
export const isEmptyObject = (value) => Object.keys(value).length === 0;
// array
export const isArray = (value) => Array.isArray(value);
export const isArrayFull = (value) => value.length > 0;
export const isEmptyArray = (value) => value.length === 0;
